import { render, staticRenderFns } from "./OfficeCard.vue?vue&type=template&id=ec6cb9e0&scoped=true&"
import script from "./OfficeCard.vue?vue&type=script&lang=js&"
export * from "./OfficeCard.vue?vue&type=script&lang=js&"
import style0 from "./OfficeCard.vue?vue&type=style&index=0&id=ec6cb9e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6cb9e0",
  null
  
)

export default component.exports